import React from 'react';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import InputBase from '@material-ui/core/InputBase';
import IconButton from '@material-ui/core/IconButton';
import SearchIcon from '@material-ui/icons/Search';
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme) => ({
    root: {
        padding: '2px 4px',
        display: 'flex',
        flexDirection: "row",
        alignItems: 'center',
        width: 300,
        height: 35,
        margin: '7px 8px',
        border: "1px solid #ccc",
        borderRadius: "4px"
    },
    input: {
        marginLeft: theme.spacing(1),
        flex: 1,
        fontSize: '14px',
    },
    iconButton: {
        padding: 10,
    },
    divider: {
        height: 28,
        margin: 4,
    },
    vinsearchbox: {
        display: 'flex',
        flexDirection: "row",
        width: 1000,
        height: 35,
    },
    vinmsg: {
        padding: '2px 4px',
        alignItems: 'center',
        width: 100,
        height: 35,
        margin: '7px 8px',
        textcolor: 'red',
    },
}));

export default function AdminSearchHeader(props) {
    const classes = useStyles();
//    const [searchtext, setSearchtext] = React.useState("");
    const [vinInput, setVinInput] = React.useState("");
    const [invalidVin, setInvalidVin] = React.useState('');

    const handleSearch = (text) => {
        if (/^[a-zA-Z0-9]*$/.test(text) === false) {
            return setInvalidVin('Invalid VIN');
        } else {
            setInvalidVin('');
        }
        setVinInput(text);
    };

    const handleSearchText = (value) => {
        handleSearch(value);
//        setSearchtext(value);
    }

    const handleSubmitbtn = (searchText, submitClck) => {
//      handleSearch(searchText);
        const vinSearch = submitClck ? vinInput : searchText;
        if (vinSearch.length < 17) {
            setInvalidVin('Invalid VIN');
        }
        if (vinSearch && vinSearch.length === 17) {
            if (props.history.location.pathname === "/adminSearchResult") {
                props.history.push("/adminSearchResult", {
                    vin: vinSearch
                });
                window.location.reload();
            }
            else {
                props.history.push("/adminSearchResult", {
                    vin: vinSearch
                });
            }
        }
    };

    const userKeyPress = event => {
        if (event?.key === 'Enter' && event?.target?.value?.length === 17) {
            event.preventDefault();
            event.stopPropagation();
            handleSubmitbtn(event.target.value)
        } else if (event?.key === 'Enter' && event?.target?.value?.length < 17) {
            setInvalidVin('Invalid VIN');
            event.preventDefault();
            event.stopPropagation();
        }
    }

    if (!localStorage.getItem('dealerCode')) {
        return (
            <div className={classes.vinsearchbox}>
                <Paper component="form" className={classes.root}>
                    <IconButton onClick={() => handleSubmitbtn('', true)} className={classes.iconButton} aria-label="search" >
                        <SearchIcon color="disabled" fontSize="small" />
                    </IconButton>
                    <InputBase
                        className={classes.input}
                        placeholder="Global Search by VIN"
                        inputProps={{ "aria-label": "search vehicle by VIN", maxLength: 17 }}
                        onChange={(evt) => { handleSearchText(evt.target.value) }}
                        onKeyPress={(evt) => userKeyPress(evt)}
                    />
                </Paper>
                {invalidVin && <Typography className={classes.vinmsg} component="p">{invalidVin}</Typography>}
            </div>
        );
    }
    else
        return (
            <div>
            </div>
        );
}
